export const appVersion = {
  version: '1.2.5',
};
